import { useScopeIds } from '@nohara-dxdev/react-oidc';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api-client';

import { getSessionsQueryKey } from './list-sessions';

export const deleteSession = async (
  orgId: string,
  projectId: string,
  sessionId: string,
): Promise<void> => {
  await api.delete(`/orgs/${orgId}/projects/${projectId}/ai-agent/sessions/${sessionId}`);
};

export const useDeleteSession = () => {
  const queryClient = useQueryClient();
  const { orgId, projectId } = useScopeIds('org', 'project');

  return useMutation({
    mutationKey: ['chat', 'sessions', 'delete'],
    mutationFn: (sessionId: string) => deleteSession(orgId, projectId, sessionId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: getSessionsQueryKey(orgId, projectId),
      });
    },
  });
};
